export const ForgotPasswordActionTypes = {
    SET_OTP: 'SET_OTP',
    SET_REFERNECE_NUM: 'SET_REFERNECE_NUM',
    SET_EMAIL:'SET_EMAIL',
    RESET_FORGET: "RESET_FORGET"
  };
  